import { TruncatedText } from "@/components";
import { hooks } from "@/styles/breakpoints";
import PaginatedText from "../../../../components/PaginatedText";
import * as styles from "./FundObjective.css";

const { useIsBelow } = hooks;

export default function FundObjective({
	title = "Fund objective",
	text,
	placement,
}: { title?: string; text: string } & styles.Variants) {
	const isBelowMd = useIsBelow("m");
	const wordLimit = isBelowMd ? 35 : 130;
	return (
		<div className={styles.wrap({ placement })}>
			<h4 className={styles.objectiveTitle({ placement })}>{title}</h4>
			<div className={styles.objectiveText({ placement })}>
				{placement === "fund-page" || isBelowMd ? (
					<TruncatedText text={text} wordLimit={wordLimit} />
				) : (
					<PaginatedText
						htmlContent={text}
						maxWordsPerPage={120}
						maxWordsPerParagraph={120}
					/>
				)}
			</div>
		</div>
	);
}
